import { getMessages } from '../../../../../../../store/constants';

export const BOARDS_COLUMN_TITLE = getMessages().getText('move_to_boards_column_title');
export const LISTS_COLUMN_TITLE = getMessages().getText('move_to_lists_column_title');
export const CARDS_COLUMN_TITLE = getMessages().getText('move_to_cards_column_title');
export const INSERT_AFTER_CARD = getMessages().getText('move_to_insert_after_card');
export const INSERT_AFTER_LIST = getMessages().getText('move_to_insert_after_list');

export const CLASS_MOVE_TO = 'move-to';
